export const counterData = [
    {
        id: 1,
        maxValue: 36,
        text: 'регионов присутствия на территории РФ',
    },
    {
        id: 2,
        maxValue: 3500000,
        text: 'клиентов по всей России уже выбрали наш интернет',
    },
    {
        id: 3,
        maxValue: 31,
        text: 'секунду в среднем клиенты ждут ответа от колл-центра',
    },
];
